import {i18n} from '@/plugins/i18n'

export const walletTransactionStatus = {
    PENDING: 1,
    SUCCESS: 2,
    FAILED: 3,
    CANCELED: 4,
    CHARGE_PENDING: 5,
    UNKNOWN_YET: 6,
    SETTLEMENT_PENDING: 7,
    CREATED: 8,
    SUCCESS_UPCOMING: 9,
    FAILED_NOT_SENT: 10,
};

export const walletTransactionStatusStr = {
    PENDING: i18n.t('label.pending'),
    SUCCESS: i18n.t('label.success'),
    FAILED: i18n.t('label.failed'),
    CANCELED:  i18n.t('label.canceled'),
    CHARGE_PENDING: i18n.t('label.charge_pending'),
    UNKNOWN_YET: i18n.t('label.unknown_yet'),
    SETTLEMENT_PENDING: i18n.t('label.settlement_pending'),
    CREATED: i18n.t('label.created'),
    SUCCESS_UPCOMING: i18n.t('label.success'),
    FAILED_NOT_SENT: i18n.t('label.failed_not_sent'),

    get(status) {
        let status_str = null;

        Object.keys(walletTransactionStatus).forEach(item => {
            if (walletTransactionStatus[item] === status) {
                status_str = walletTransactionStatusStr[item];
            }
        });

        return status_str;
    }
};

export const walletTransactionStatusVariant = (status, isReversal = false) => {
    if (status === walletTransactionStatus.SUCCESS && isReversal) {
        return 'danger';
    }

    switch (status) {
        case walletTransactionStatus.SUCCESS:
        case walletTransactionStatus.SUCCESS_UPCOMING:
            return 'success';
        case walletTransactionStatus.FAILED:
        case walletTransactionStatus.CANCELED:
        case walletTransactionStatus.FAILED_NOT_SENT:
            return 'danger';
        case walletTransactionStatus.CREATED:
        case walletTransactionStatus.PENDING:
        case walletTransactionStatus.CHARGE_PENDING:
        case walletTransactionStatus.SETTLEMENT_PENDING:
            return 'warning';
    }

    return 'primary';
};
